import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { Link } from 'react-router-dom';
import styles from './LeftNavigation.module.css';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { IconLookup as iconLookup } from '@gscope-mfe/app-bridge';
import { Utilities } from '@gscope-mfe/app-bridge';
const { makeStyles } = MaterialUiCore;
const { Grid, OutlinedInput, InputAdornment } = MaterialUiCore;
const { setUserPreference } = Utilities;
const useStyles = makeStyles(() => ({
    searchInput: {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
            borderWidth: '1px !important',
        },
        '& .MuiInputBase-input': {
            color: 'var(--nav-text-color)',
            paddingBottom: '21px',
        },
    },
    navDrawer: {
        '& .sct-icon': {
            color: 'var(--nav-icon-color) !important',
            fontSize: '28px',
            padding: '5px 5px 5px 7px',
        },
    },
    mainContainer: {
        '& .sct-icon': {
            color: 'var(--nav-icon-color) !important',
        },
        '& .sct-icon:before': {
            color: 'var(--nav-icon-color) !important',
        },
    },
}));

const LeftNavigation = (props) => {
    const [showDrawer, setShowDrawer] = React.useState(false);
    const [selectedBucket, setSelectedBucket] = React.useState('');
    const [pinnedModules, setPinnedModules] = React.useState([]);
    const [pinnedBuckets, setPinnedBuckets] = React.useState([]);
    const [selectedBucketsObj, setSelectedBucketsObj] = React.useState({});
    const [searching, setSearching] = React.useState(false);
    const [searchMatches, setSearchMatches] = React.useState({});
    const [collapseChildNav, setCollapseChildNav] = React.useState(false);
    const [collapseGscopePages, setCollapseGscopePages] = React.useState(false);
    const [drawerScrollPresent, setDrawerScrollPresent] = React.useState(false);
    const [stripScrollPresent, setStripScrollPresent] = React.useState(false);
    const { bucketsLookup, userPref } = props;
    const { headerConfig, userInfo, setloading, setUserPref, moduleNavConfig } = AppUtils.get();
    const classes = useStyles();
    React.useEffect(() => {
        if (collapseGscopePages) {
            setSelectedBucket('');
            setSelectedBucketsObj({});
        }
    }, [collapseGscopePages]);
    React.useEffect(() => {
        if (bucketsLookup && Object.keys(bucketsLookup).length) {
            getPinnedModules();
        }
    }, [bucketsLookup, userPref]);
    React.useEffect(() => {
        if (searching) {
            setSelectedBucket('');
            setSelectedBucketsObj({});
        } else setSearchMatches({});
    }, [searching]);
    React.useEffect(() => {
        setCollapseChildNav(false);
        setCollapseGscopePages(false);
    }, [moduleNavConfig]);
    React.useEffect(() => {
        setDrawerScrollPresent(isScrollPresent('bucketsList'));
        setStripScrollPresent(isScrollPresent('sideNavStrip'));
    });

    const getPinnedModules = () => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        const pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        const pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        const pageDetails = getModulesFromAbbreviations(pinnedModulesForMarket);
        setPinnedModules(pinnedModulesForMarket);
        setPinnedBuckets(pageDetails);
        return pageDetails;
    };

    const getModulesFromAbbreviations = (pagesArray) => {
        let buckets = {};
        pagesArray.forEach((page) => {
            const pageKeys = page.split('.');
            pageKeys.splice(0, 1);

            if (
                pageKeys &&
                pageKeys.length == 2 &&
                bucketsLookup[pageKeys[0]] &&
                bucketsLookup[pageKeys[0]].pages &&
                bucketsLookup[pageKeys[0]].pages[pageKeys[1]]
            ) {
                if (!buckets[pageKeys[0]]) {
                    buckets[pageKeys[0]] = {
                        name: bucketsLookup[pageKeys[0]].name,
                        pages: {},
                    };
                }

                buckets[pageKeys[0]].pages[pageKeys[1]] = {
                    name: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].name,
                    route: bucketsLookup[pageKeys[0]].pages[pageKeys[1]].route,
                };
            }
        });
        return buckets;
    };

    const openSideMenu = () => {
        setShowDrawer(true);
    };

    const closeSideMenu = () => {
        setShowDrawer(false);
        setSearching(false);
        setSelectedBucket('');
        setSelectedBucketsObj({});
    };

    const positionPagesMenu = () => {
        const targetEl = document.getElementsByClassName(styles['selected-nav-item'])[0];
        if (!targetEl) return;
        const eleTop = targetEl.getBoundingClientRect().top;
        let eleBtm = window.innerHeight - targetEl.getBoundingClientRect().bottom;
        if (eleBtm < 0) eleBtm = 0;
        const eleHeight = document.getElementById('leftNavPageContainer').offsetHeight + 10;
        const vwHeight = window.innerHeight;

        if (vwHeight - eleTop > eleHeight) {
            document.getElementById('leftNavPageContainer').style.top = `${eleTop}px`;
        } else if (vwHeight - eleBtm > eleHeight) {
            let yPos = vwHeight - eleBtm - document.getElementById('leftNavPageContainer').offsetHeight;
            if (yPos < 0) yPos = 0;
            document.getElementById('leftNavPageContainer').style.top = `${yPos}px`;
        } else {
            if (vwHeight - eleTop > vwHeight - eleBtm) {
                document.getElementById('leftNavPageContainer').style.top = `${eleTop}px`;
                document.getElementById('leftNavPageContainer').style.maxHeight = `calc(100vh - ${eleTop}px)`;
            } else {
                document.getElementById('leftNavPageContainer').style.maxHeight = `calc(100vh - ${eleBtm}px)`;
                let yPos = vwHeight - eleBtm - document.getElementById('leftNavPageContainer').offsetHeight;
                if (yPos < 0) yPos = 0;
                document.getElementById('leftNavPageContainer').style.top = `${yPos}px`;
            }
        }

        document.getElementById('leftNavPageContainer').style.visibility = 'visible';
    };

    const openPagesDrawer = (event, key) => {
        setSelectedBucket(key);
        const bucketObj = {};
        bucketObj[key] = bucketsLookup[key];
        setSelectedBucketsObj({ ...bucketObj });
    };

    const pinModule = (pageKey) => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        const index = pinnedModulesForMarket.findIndex((page) => page === pageKey);

        if (index == -1) {
            pinnedModulesForMarket.push(pageKey);
            pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    getPinnedModules();
                    triggerUserPrefChange();
                })
                .finally(() => setloading(false));
        }
    };

    const unPinModule = (pageKey) => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        const index = pinnedModulesForMarket.findIndex((page) => page === pageKey);

        if (index > -1) {
            pinnedModulesForMarket.splice(index, 1);
            pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    const pinnedBucketsObj = getPinnedModules();
                    triggerUserPrefChange();
                    if (selectedBucket == 'pinnedModules') setSelectedBucketsObj({ ...pinnedBucketsObj });
                })
                .finally(() => setloading(false));
        }
    };

    const triggerUserPrefChange = () => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        setUserPref(preferences);
    };

    const openPinnedModules = (event) => {
        setSelectedBucket('pinnedModules');
        setSelectedBucketsObj({ ...pinnedBuckets });
    };

    const searchStringChange = (event) => {
        if (!event || !event.target || !event.target.value || event.target.value.trim() == '') {
            setSearchMatches({});
            return;
        }

        const val = event.target.value;
        let matchingBuckets = {};
        Object.keys(bucketsLookup).forEach((bucket) => {
            let matchingPages = {};
            Object.keys(bucketsLookup[bucket].pages).forEach((page) => {
                let name = bucketsLookup[bucket].pages[page].name;

                if (name) {
                    name = name.toLowerCase();

                    if (name.includes(val.toLowerCase())) {
                        matchingPages[page] = { ...bucketsLookup[bucket].pages[page] };
                    }
                }
            });

            if (Object.keys(matchingPages).length) {
                matchingBuckets[bucket] = { ...bucketsLookup[bucket] };
                matchingBuckets[bucket].pages = matchingPages;
            }
        });
        setSearchMatches({ ...matchingBuckets });
    };

    const clearSearchField = () => {
        document.getElementById('searchPagesInput').value = '';
        searchStringChange();
    };

    const isScrollPresent = (id) => {
        const el = document.getElementById(id);

        if (el) {
            if (el.scrollHeight > el.clientHeight) {
                return true;
            } else {
                return false;
            }
        }
    };

    const scrollPages = () => {
        document.getElementById('bucketsList').scrollTop += document.getElementById('bucketsList').clientHeight;
    };

    const PageList = ({ buckets }) => {
        if (buckets && Object.keys(buckets).length > 0) {
            return Object.keys(buckets)
                .sort((a, b) => {
                    if (buckets[a].name < buckets[b].name) {
                        return -1;
                    }

                    if (buckets[a].name > buckets[b].name) {
                        return 1;
                    }

                    return 0;
                })
                .map((bucket, index) => {
                    return buckets[bucket].pages && Object.keys(buckets[bucket].pages).length > 0 ? (
                        <Grid key={index} className={styles['bucketed-pages']}>
                            {Object.keys(buckets).length > 1 && (
                                <div className={styles['bucket-title']}>{buckets[bucket].name}</div>
                            )}
                            {Object.keys(buckets[bucket].pages)
                                .sort((a, b) => {
                                    if (buckets[bucket].pages[a].name < buckets[bucket].pages[b].name) {
                                        return -1;
                                    }

                                    if (buckets[bucket].pages[a].name > buckets[bucket].pages[b].name) {
                                        return 1;
                                    }

                                    return 0;
                                })
                                .map((page, pg_index) => {
                                    if (
                                        !buckets[bucket].pages[page].hiddenPage &&
                                        buckets[bucket].pages[page].route &&
                                        buckets[bucket].pages[page].route.trim().length > 0
                                    ) {
                                        return (
                                            <Grid
                                                key={Number(`${index}${pg_index}`)}
                                                container
                                                direction="row"
                                                className={`${styles['page-name-container']}`}
                                            >
                                                {pinnedModules.indexOf(`${userInfo.currentMarket}.${bucket}.${page}`) >
                                                -1 ? (
                                                    <i
                                                        className={
                                                            'sct-icon icon-Pinned-b15x ' +
                                                            `${styles['unpin-icon']} ${styles['pin-page-icon']}`
                                                        }
                                                        onClick={() =>
                                                            unPinModule(`${userInfo.currentMarket}.${bucket}.${page}`)
                                                        }
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className={`sct-icon icon-UnPinned-b15x ${styles['pin-page-icon']}`}
                                                        onClick={() =>
                                                            pinModule(`${userInfo.currentMarket}.${bucket}.${page}`)
                                                        }
                                                    ></i>
                                                )}
                                                <Link
                                                    className={styles['page-name']}
                                                    to={buckets[bucket].pages[page].route}
                                                    onClick={closeSideMenu}
                                                >
                                                    {buckets[bucket].pages[page].name}
                                                </Link>
                                            </Grid>
                                        );
                                    }
                                })}
                            {Object.keys(buckets).length > 1 && index + 1 < Object.keys(buckets).length && (
                                <hr className={styles['horizontal-separator']}></hr>
                            )}
                        </Grid>
                    ) : null;
                });
        } else null;
    };

    const PagesMenu = ({ buckets }) => {
        React.useEffect(() => {
            positionPagesMenu();
        }, []);

        if (buckets && Object.keys(buckets).length > 0) {
            return (
                <Grid id="pagesMenu" container item className={styles['page-drawer']} direction="row">
                    <Grid
                        item
                        id="leftNavPageContainer"
                        className={`${styles['page-container']} ${styles['page-scroll']}`}
                    >
                        <PageList buckets={buckets} />
                    </Grid>
                </Grid>
            );
        } else null;
    };

    return bucketsLookup ? (
        <Grid container className={`${styles['side-menu-container']} ${classes.mainContainer}`}>
            <Grid
                item
                container
                className={styles['side-nav-strip']}
                id="sideNavStrip"
                onMouseEnter={openSideMenu}
                alignItems="flex-start"
            >
                <Grid item className={`${styles['nav-item-thumbnail']} ${styles['menu-icon']}`} onClick={openSideMenu}>
                    <span className={`${styles['thumbnail-icon']} sct-icon icon-Menu-18`} id="menuButton" />
                </Grid>
                {pinnedModules && pinnedModules.length ? (
                    <div>
                        <Grid className={styles['nav-item-thumbnail']}>
                            <span className={`${styles['thumbnail-icon']} sct-icon icon-UnPinned-b15x`} />
                        </Grid>
                        <hr className={styles['horizontal-separator']}></hr>
                    </div>
                ) : null}

                {moduleNavConfig && moduleNavConfig.navItems && moduleNavConfig.navItems.length > 0 ? (
                    <Grid item container>
                        <div
                            style={{
                                height: '32px',
                                width: '100%',
                            }}
                        ></div>
                        {moduleNavConfig.navItems.map((item, index) => {
                            return (
                                <Grid
                                    key={index}
                                    item
                                    className={
                                        styles['nav-item-thumbnail'] +
                                        (function () {
                                            if (window.location.pathname === item.route)
                                                return ` ${styles['selected-nav-thumbnail']}`;
                                            else return '';
                                        })()
                                    }
                                >
                                    <span className={`sct-icon ${item.icon} ${styles['thumbnail-icon']}`} />
                                </Grid>
                            );
                        })}
                        <hr className={styles['horizontal-separator']}></hr>
                        <div
                            style={{
                                height: '31px',
                                width: '100%',
                            }}
                        ></div>
                    </Grid>
                ) : null}

                {Object.keys(bucketsLookup)
                    .sort((a, b) => {
                        if (bucketsLookup[a].name < bucketsLookup[b].name) {
                            return -1;
                        }

                        if (bucketsLookup[a].name > bucketsLookup[b].name) {
                            return 1;
                        }

                        return 0;
                    })
                    .map((bucket, index) => {
                        return (
                            <Grid key={index} item className={styles['nav-item-thumbnail']}>
                                <span
                                    className={`sct-icon ${
                                        iconLookup[bucketsLookup[bucket].icon] &&
                                        iconLookup[bucketsLookup[bucket].icon].name
                                    } ${styles['thumbnail-icon']}`}
                                />
                            </Grid>
                        );
                    })}

                {stripScrollPresent && (
                    <div className={styles['view-more-thumbnail']}>
                        <i className={`sct-icon icon-Arrow-Down-18 ${styles['icon-Arrow-Down-18']}`}></i>
                    </div>
                )}
            </Grid>

            {showDrawer && (
                <Grid item container direction="column" className={`${styles['side-nav-drawer']} ${classes.navDrawer}`}>
                    <div className={styles['drawer-overlay']} onClick={closeSideMenu}></div>

                    {searching ? (
                        <Grid item className={styles['bucket-drawer']}>
                            <OutlinedInput
                                className={`${styles['search-input']} ${classes.searchInput}`}
                                placeholder="Search gscope pages"
                                variant="filled"
                                fullWidth
                                autoFocus
                                autoComplete="off"
                                id="searchPagesInput"
                                onChange={searchStringChange}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <i
                                            className={`sct-icon icon-Arrow-Left-18 ${styles['back-icon']}`}
                                            onClick={() => {
                                                setSearching(false);
                                                setSearchMatches({});
                                            }}
                                        ></i>
                                    </InputAdornment>
                                }
                                endAdornment={
                                    <InputAdornment position="end">
                                        <i
                                            className={`sct-icon ${styles['clear-icon']} icon-Remove-18`}
                                            onClick={clearSearchField}
                                        ></i>
                                    </InputAdornment>
                                }
                            />
                            {searchMatches && Object.keys(searchMatches).length ? (
                                <Grid container className={styles['search-items']}>
                                    <PageList buckets={searchMatches} />
                                </Grid>
                            ) : null}
                        </Grid>
                    ) : (
                        <Grid
                            item
                            className={styles['bucket-drawer']}
                            onMouseLeave={() => (!selectedBucket || selectedBucket.length == 0) && closeSideMenu()}
                        >
                            <Grid item className={styles['side-menu-header']}>
                                <span className={`${styles['thumbnail-icon']} sct-icon icon-Menu-18`} />
                                <span className={styles['branding']}>
                                    <img src={headerConfig.logo} alt="Logo" height={25} width={25} />
                                    <Link onClick={closeSideMenu} to="/apphome" className={styles['title']}>
                                        GSCOPE
                                    </Link>
                                </span>
                                <i
                                    className={`sct-icon icon-Search-18 ${styles['sidenav-search-icon']}`}
                                    onClick={() => setSearching(true)}
                                ></i>
                            </Grid>

                            <div className={styles['buckets-list-wrapper']}>
                                <Grid item container className={styles['buckets-list']} id="bucketsList">
                                    {pinnedModules && pinnedModules.length ? (
                                        <div className={styles['pinned-module-wrapper']}>
                                            <div id="pinnedModulesSection" className={styles['pinned-modules-section']}>
                                                <Grid
                                                    item
                                                    className={
                                                        styles['nav-item'] +
                                                        (function () {
                                                            if (selectedBucket === 'pinnedModules')
                                                                return ` ${styles['selected-nav-item']}`;
                                                            else if (
                                                                selectedBucket !== '' &&
                                                                selectedBucket !== 'pinnedModules'
                                                            )
                                                                return ` ${styles['opaque-item']}`;
                                                            else return '';
                                                        })()
                                                    }
                                                    onMouseEnter={openPinnedModules}
                                                >
                                                    <span
                                                        className={`${styles['sct-icon']} sct-icon icon-UnPinned-b15x`}
                                                    />
                                                    <span className={styles['item-text']}>Pinned Modules</span>
                                                    <span
                                                        className={`${styles['sct-icon']} ${styles['icon-Arrow-Right-18']} sct-icon icon-Arrow-Right-18`}
                                                    ></span>
                                                </Grid>
                                                <hr className={styles['horizontal-separator']}></hr>
                                            </div>
                                            <div
                                                style={{
                                                    height: '89px',
                                                }}
                                            ></div>
                                        </div>
                                    ) : null}

                                    {moduleNavConfig &&
                                    moduleNavConfig.navItems &&
                                    moduleNavConfig.navItems.length > 0 ? (
                                        <Grid
                                            id="moduleSubLinksSections"
                                            item
                                            container
                                            className={styles['module-sublinks']}
                                        >
                                            <div
                                                className={styles['nav-item-title']}
                                                onClick={() => setCollapseChildNav(!collapseChildNav)}
                                            >
                                                {moduleNavConfig.title}
                                                {!collapseChildNav ? (
                                                    <i
                                                        className={`${styles['sct-icon']} sct-icon icon-Arrow-Down-18`}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className={`${styles['sct-icon']} sct-icon icon-Arrow-Right-18`}
                                                    ></i>
                                                )}
                                            </div>
                                            {!collapseChildNav && (
                                                <div
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                >
                                                    {moduleNavConfig.navItems.map((item, index) => {
                                                        return (
                                                            <Link
                                                                key={index}
                                                                to={item.route}
                                                                onClick={closeSideMenu}
                                                                className={
                                                                    styles['nav-item'] +
                                                                    (function () {
                                                                        if (window.location.pathname === item.route)
                                                                            return ` ${styles['current-child-page']}`;
                                                                        else return '';
                                                                    })()
                                                                }
                                                            >
                                                                <span
                                                                    className={`${styles['sct-icon']} sct-icon ${item.icon}`}
                                                                />
                                                                <span className={styles['item-text']}>{item.name}</span>
                                                            </Link>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                            <hr className={styles['horizontal-separator']}></hr>
                                        </Grid>
                                    ) : null}

                                    {
                                        <Grid id="gscopeModulesSection" className={styles['gscope-modules']}>
                                            {moduleNavConfig &&
                                                moduleNavConfig.navItems &&
                                                moduleNavConfig.navItems.length > 0 && (
                                                    <div
                                                        className={styles['nav-item-title']}
                                                        onClick={() => setCollapseGscopePages(!collapseGscopePages)}
                                                    >
                                                        GSCOPE
                                                        {!collapseGscopePages ? (
                                                            <i
                                                                className={`${styles['sct-icon']} sct-icon icon-Arrow-Down-18`}
                                                            ></i>
                                                        ) : (
                                                            <i
                                                                className={`${styles['sct-icon']} sct-icon icon-Arrow-Right-18`}
                                                            ></i>
                                                        )}
                                                    </div>
                                                )}
                                            {!collapseGscopePages &&
                                                Object.keys(bucketsLookup)
                                                    .sort((a, b) => {
                                                        if (bucketsLookup[a].name < bucketsLookup[b].name) {
                                                            return -1;
                                                        }

                                                        if (bucketsLookup[a].name > bucketsLookup[b].name) {
                                                            return 1;
                                                        }

                                                        return 0;
                                                    })
                                                    .map((bucket, index) => {
                                                        return (
                                                            <Grid
                                                                key={index}
                                                                className={
                                                                    styles['nav-item'] +
                                                                    (function () {
                                                                        if (selectedBucket === bucket)
                                                                            return ` ${styles['selected-nav-item']}`;
                                                                        else if (
                                                                            selectedBucket !== '' &&
                                                                            selectedBucket !== bucket
                                                                        )
                                                                            return ` ${styles['opaque-item']}`;
                                                                        else return '';
                                                                    })()
                                                                }
                                                                onMouseEnter={(e) => openPagesDrawer(e, bucket)}
                                                            >
                                                                <span
                                                                    className={`${styles['sct-icon']} sct-icon ${
                                                                        iconLookup[bucketsLookup[bucket].icon] &&
                                                                        iconLookup[bucketsLookup[bucket].icon].name
                                                                    }`}
                                                                />
                                                                <span className={styles['item-text']}>
                                                                    {bucketsLookup[bucket].name}
                                                                </span>
                                                                <span
                                                                    className={`${styles['sct-icon']} ${styles['icon-Arrow-Right-18']} sct-icon icon-Arrow-Right-18`}
                                                                ></span>
                                                            </Grid>
                                                        );
                                                    })}
                                        </Grid>
                                    }
                                </Grid>

                                {drawerScrollPresent && (
                                    <div className={styles['view-more-text']} onClick={scrollPages}>
                                        <span className={styles['view-more-span']}>
                                            View more
                                            <i
                                                className={`sct-icon icon-Arrow-Down-18 ${styles['icon-Arrow-Down-18']}`}
                                            ></i>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </Grid>
                    )}

                    {selectedBucketsObj && Object.keys(selectedBucketsObj).length > 0 ? (
                        <PagesMenu buckets={selectedBucketsObj}></PagesMenu>
                    ) : null}
                </Grid>
            )}
        </Grid>
    ) : null;
};

export default LeftNavigation;
